import { Card } from '@/components/Bicester';
import React from 'react';
import ServiceInfo from '../../components/ServiceInfo';
import { fetchAddEditSuggest, fetchSuggestInfo } from '@/services/site/suggest';
import { defaultSuggestEditInfo, suggestSchema } from '../../Suggest/constants';
import { getParamsWithNilToString } from '@/services/utils';
import _ from 'lodash';
import useCasesBasic from '@/hooks/preload/useCasesBasic';
import useGePcsList from '@/hooks/preload/useGePcsList';
import useSiteBrandList from '@/hooks/preload/useSiteBrandList';

const SuggestInfo = () => {
  const { data: casesBasic } = useCasesBasic();
  const { data: gePcsList } = useGePcsList();
  const { data: brandList } = useSiteBrandList();

  return (
    <ServiceInfo
      defaultServiceInfo={defaultSuggestEditInfo}
      serviceSchema={suggestSchema}
      fetchInfo={fetchSuggestInfo}
      fetchEdit={fetchAddEditSuggest}
      getDefaultInfo={(data) => {
        return {
          shopping_village: data?.shopping_village,
          cases_day: data?.cases_day,
          cases_receive_day: data?.cases_receive_day,
          cases_source: !_.isNil(data?.cases_source) && Number(data?.cases_source),
          cases_brand: data?.cases_brand,
          cases_category: data?.cases_category?.map((item) => Number(item.cases_category_id)),
          cases_remark: data?.cases_remark,
          dispose_ge_id: data?.dispose_ge_id,
          cases_status: data?.cases_status,
          dispose_retail_id: data?.dispose_retail_id,
          cases_dispose: data?.cases_dispose?.map((item) => Number(item.cases_dispose_id)),
          dispose_remark: data?.dispose_remark,
          dispose_result: data?.dispose_result,
        };
      }}
      handleBeforeSubmit={(formik, values) => {
        // 校验投诉问题分类是否各个分类至少选一项
        if (values.cases_category?.length) {
          const categoryGroupArr = casesBasic.category?.reduce((pre, cur) => {
            return pre.includes(cur?.role) ? pre : pre?.concat(cur?.role);
          }, []);
          const selectedGroupArr = values.cases_category?.reduce((pre, cur) => {
            const role = casesBasic.category?.find((cate) => cate?.value === cur)?.role;
            return !_.isNil(role) && !pre.includes(role) ? pre?.concat(role) : pre;
          }, []);
          if (selectedGroupArr.length < categoryGroupArr.length) {
            formik.setFieldError('cases_category', '各分类至少选一项');
            return false;
          }
        }
        return true;
      }}
      getSubmitData={(id, values) =>
        Object.assign({}, getParamsWithNilToString(values), {
          cases_category: JSON.stringify(
            values?.cases_category?.map((item) => {
              return {
                cases_category_id: item,
              };
            }) ?? []
          ),
          cases_dispose: JSON.stringify(
            values?.cases_dispose?.map((item) => {
              return {
                cases_dispose_id: item,
              };
            }) ?? []
          ),
          id,
        })
      }
      serviceInfo={({ formik, infoData, isEdit }) => (
        <>
          <Card.Input
            notEditable
            label="投诉发生购物村"
            formKey="village"
            inputType="village"
            value={infoData?.shopping_village}
          />
          <Card.Input
            notEditable
            label="投诉事件编号"
            formKey="service_no"
            value={infoData?.service_no}
          />
          <Card.DatePicker required isEdit={isEdit} label="投诉发生日期" formKey="cases_day" />
          <Card.DatePicker
            required
            isEdit={isEdit}
            label="投诉接收日期"
            formKey="cases_receive_day"
          />
          <Card.Picker
            required
            isEdit={isEdit}
            label="投诉来源"
            formKey="cases_source"
            pickerData={casesBasic.source}
            searchable
          />
          <Card.Picker
            isEdit={isEdit}
            label="被投诉对象"
            formKey="cases_brand"
            pickerData={brandList}
            value={infoData?.cases_brand}
            searchable
          />
          <Card.CheckPicker
            isEdit={isEdit}
            label="投诉问题分类"
            formKey="cases_category"
            pickerData={casesBasic.category}
            groupBy="role"
            renderMenuGroup={(title, node) => `${title} - 至少选择一项`}
            searchable
          />
          <Card.Input
            isEdit={isEdit}
            label="投诉具体描述"
            formKey="cases_remark"
            inputType="textarea"
          />
        </>
      )}
      thirdCardInfo={({ formik, infoData, isEdit }) => (
        <Card title="处理进度">
          <Card.Picker
            isEdit={isEdit}
            label="投诉处理大使"
            formKey="dispose_ge_id"
            pickerData={gePcsList.ge_list}
            value={infoData?.dispose_ge_name}
            searchable
          />
          <Card.Picker
            required
            isEdit={isEdit}
            label="投诉处理状态"
            formKey="cases_status"
            pickerData={casesBasic.cases_status}
          />
          <Card.Picker
            isEdit={isEdit}
            label="协助零售经理"
            formKey="dispose_retail_id"
            pickerData={casesBasic.retails}
            value={infoData?.dispose_retail_name}
            searchable
          />
          <Card.CheckPicker
            isEdit={isEdit}
            label="赔偿内容"
            formKey="cases_dispose"
            pickerData={casesBasic.dispose_type}
            searchable
          />
          <Card.Input
            isEdit={isEdit}
            label="处理详情"
            formKey="dispose_remark"
            inputType="textarea"
          />
          <Card.Input
            isEdit={isEdit}
            label="处理结果"
            formKey="dispose_result"
            inputType="textarea"
          />
        </Card>
      )}
    />
  );
};

export default SuggestInfo;
